<template>
  <v-dialog persistent :value="value" max-width="350px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Delete User?</span>
      </v-card-title>

      <v-divider class="mb-2"/>

      <v-card-text>
        Are you sure you want to delete this user?  This can not be undone...
      </v-card-text>

      <v-divider />


      <v-card-actions class="justify-end">
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="onDelete">Delete</v-btn>
      </v-card-actions>
    </v-card>
    <ErrorOverlay
      title="Delete User Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </v-dialog>
</template>      
 
<script>
import { mapActions } from "vuex";
import ErrorOverlay from '@/components/pages/ErrorOverlay';

export default {
  name: 'ProUserDeleteDialog',

  props: ['value', 'pro_user'],

  components: { ErrorOverlay },

  data: () => ({
    // error handling
    loading: false,
    error_dialog: false,
    error_message: "",
  }),

  methods: {
    ...mapActions('pro_users', ['deleteUser']),

    close() {
      this.$emit('input', false)
    },

    async onDelete() {
      let { pro_user } = this
      this.loading = true
      const result = await this.deleteUser( pro_user )
      this.loading = false

      if (result.ok) {
        this.close()
      } else {
        this.error_dialog = true
        this.error_message = result.error
      }
    },
  },
};
</script>